export const BACKGROUND_TYPE = {
  COLOR: 0,
  IMG: 1,
};

export const CONST_DEL_SUBMENU_TITLE_FILTER = {
  ALL: -1,
  HIDE_DEL: 1,
  SHOW_DEL: 0,
};
